import React, { Component } from 'react';
import DateTime from 'react-datetime';

import './../../../node_modules/react-datetime/css/react-datetime.css';

class ApvForm extends Component
{
    constructor(props)
    {
        super(props);

        this.onChange = props.onChange;
        
        this.handeInput = this.handeInput.bind(this);
        this.handleDate = this.handleDate.bind(this);

        this.DateTime = React.createRef();
    }

    handeInput(event)
    {
        let value = event.target.type === 'checkbox' ? (event.target.checked === true ? 1 : 0) : event.target.value;
        let evt = {
            "target" : {
                "name" : event.target.name,
                "value" : value
            } 
        }
        
        this.onChange(evt);
    }

    handleDate(ref, name, date)
    {
        ref.current.querySelector('.text-danger').style.display = "none";
        ref.current.querySelector('.rdt .form-control').classList.remove("invalid")
        if(date._isAMomentObject == null)
        {
            ref.current.querySelector('.text-danger').style.display = "initial";
            ref.current.querySelector('.rdt .form-control').classList.add("invalid");
            let evt = {
                "target" : {
                    "name" : name,
                    "value" : null
                } 
            }
            this.onChange(evt);
            return;
        }
        else
        {
            let evt = {
                "target" : {
                    "name" : name,
                    "value" : date.unix()
                } 
            }
            this.onChange(evt);
        }
    }

    render()
    {
        return (
            <div className="fade modal show" id="addAPVModal" tabIndex="-1" role="dialog" aria-labelledby="addAPVModalLabel" aria-modal="true">
            <div className="modal-dialog modal-full-height modal-right" role="document">
                <div className="modal-content rounded-0 p-3">
                    <button type="button" className="close closeSideModal" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                    <div className="modal-header">
                        <h4 className="modal-title" id="addAPVModalLabel">Ajouter un APV</h4>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        N° Facture
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="facture" value={ this.props.apv.facture } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 100 caractères.
                                    </small>
                                </div>
                    
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Nom affaire
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="name" value={ this.props.apv.name } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 100 caractères.
                                    </small>
                                </div>

                                <div className="form-group" ref={ this.DateTime }>
                                    <label className="h5 font-weight-bold">
                                        Date facture
                                    </label>
                                    <DateTime name="date" timeFormat={ false } onChange={ (date) => { this.handleDate(this.DateTime, "date", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.apv.date != null ? this.props.apv.date*1000 : null } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir une date valide
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Commentaires
                                    </label>
                                    <textarea type="text" maxLength="400" className="form-control" name="comments" value={ this.props.apv.comments } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 400 caractères.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Montant facture
                                    </label>
                                    <input type="number" lang="en" step="0.01" className="form-control" name="amount" value={ this.props.apv.amount } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir un nombre entre 0 et 10. Utilisez "." et non ",".
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Immatriculation
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="code" value={ this.props.apv.code } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 100 caractères.
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Kilométrage
                                    </label>
                                    <input type="number" min="0" max="999 999"  className="form-control" name="km" value={ this.props.apv.km } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir un nombre entier entre 0 et 999 999.
                                    </small>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className='btn btn-primary float-right' onClick={()=> this.props.onSubmit()}>
                            <li className='fas fa-save'> </li> Enregistrer
                        </button>
                    </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ApvForm;


// WEBPACK FOOTER //
// ./src/Components/APV/ApvForm.js